module.exports = __webpack_public_path__ + "static/media/right-arrow.64c224f4.svg";